<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('table_search') || '补货计划/区域 搜索...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditDialog', { type: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form ref="form" :model="form" size="mini">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.Status') || '有效状态'">
              <el-checkbox-group v-model="form.listAmzPeriodStatus">
                <el-checkbox label="N">
                  {{ $l('INDEX.form_label_status_draft') || '草稿' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('INDEX.form_label_status_enabled') || '已启用' }}
                </el-checkbox>
                <el-checkbox label="C">
                  {{ $l('INDEX.form_label_status_closed') || '已关闭' }}
                </el-checkbox>
                <el-checkbox label="D">
                  {{ $l('INDEX.form_label_status_deleted') || '已删除' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_planNo') || '补货计划编号'">
              <el-input
                v-model="form.planNo"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_amzPeriodTitle') || '补货计划标题'"
            >
              <el-input
                v-model="form.amzPeriodTitle"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_amazonStoreRegion') || '店铺区域'"
            >
              <dict-select
                v-model="form.amazonStoreRegion"
                url="/ecom/amz/market/dictSelect"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
                filterable
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_skuSalesChannel') || '产品售卖渠道'"
            >
              <dict-select
                v-model="form.skuSalesChannel"
                url="/sys/common/dict/system"
                :body="{ dictType: 'skuSalesChannel' }"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
                filterable
                size="mini"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('form_label_labelingType') || '贴标方式'">
              <dict-select
                v-model="form.labelingType"
                url="/master/common/dict/biz"
                :body="{ dictType: 'labelingType' }"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
                filterable
                size="mini"
                style="width:100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('form_label_shippingDate') || '预计发运日期'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.shippingDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.shippingDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_label_etaDate') || '预计到货日期'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.etaDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.etaDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_shipPlanType') || '发运计划类型'"
            >
              <dict-select
                v-model="form.shipPlanType"
                url="/master/common/dict/biz"
                :body="shipPlanTypeParams"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
                filterable
                style="width:100%"
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('form_label_shipPlanRange') || '补货范围'">
              <el-select
                v-model="form.shipPlanRange"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                clearable
                style="width:100%"
                size="mini"
              >
                <el-option
                  :label="$l('form_label_shipPlanRange_a') || '全部店铺'"
                  value="A"
                >
                </el-option>
                <el-option
                  :label="$l('form_label_shipPlanRange_b') || '指定店铺'"
                  value="B"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_label_fillingDate') || '填报时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('INDEX.table_label_created_date') || '创建时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '', listAmzPeriodStatus: ['N', 'Y', 'C'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      shipPlanTypeParams: { dictType: 'shipPlanType' },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
